<template>
  <div class="cg-toolbar">
    <img v-show="$route.fullPath === '/cloud/lobby'" class="cg-toolbar-icon click" src="../img/back.svg" @click="$emit('back')" alt="Go Back" title="Go Back" />
    <img v-show="$route.fullPath === '/cloud/teacher-login'" class="cg-toolbar-icon click" src="../img/back.svg" @click="$emit('back')" alt="Go Back" title="Go Back" />
    <img v-show="$route.fullPath === '/cloud/teacher'" class="cg-toolbar-icon click" src="../img/back.svg" @click="$emit('back')" alt="Go Back" title="Go Back" />
    <img v-show="$route.fullPath.indexOf('/cloud/analytics') === 0" class="cg-toolbar-icon click" src="../img/back.svg" @click="$router.go(-1)" alt="Go Back" title="Go Back" />
    <img class="cg-toolbar-icon click" src="../img/logo.svg" @click="$emit('logo')" alt="Logo" title="Logo" />
    <img v-show="$route.fullPath !== '/cloud/lobby'" class="cg-toolbar-icon click" src="../img/student.svg" @click="$emit('student')" alt="Student" title="Student" />
    <img v-show="$route.fullPath !== '/cloud/teacher'" class="cg-toolbar-icon click" src="../img/teacher.svg" @click="$emit('teacher')" alt="Teacher" title="Teacher" />
    <img class="cg-toolbar-icon click" src="../img/chat.svg" @click="$emit('chat')" alt="FeedBack" title="FeedBack" />
    <img class="cg-toolbar-icon click" src="../img/twitter.svg" @click="$emit('twitter')" alt="Twitter" title="Twitter" />
    <img class="cg-toolbar-icon click" src="../img/help.svg" @click="$emit('game-rule')" alt="GameRule" title="GameRule" />
    <img class="cg-toolbar-icon click" src="../img/logout.svg" @click="$emit('logout')" alt="Logout" title="Logout" />
  </div>
</template>

<script>
import * as sAPI from '../api/strapi'
export default {
  created () {
    this.$on('logo', () => {
      window.open('https://sites.google.com/view/cell-game')
    })
    this.$on('twitter', () => {
      window.open('https://twitter.com/the_cell_game')
    })
    this.$on('game-rule', () => {
      window.open('https://sites.google.com/view/cell-game/rules')
    })
    this.$on('chat', () => {
      window.open('https://yoteachapp.com/lab/Cell_game_feedback')
    })
    this.$on('lobby', () => {
      this.$router.push(`/cloud/lobby`)
      // window.location.assign('/cloud/teacher')
    })
    this.$on('back', () => {
      this.$router.push(`/cloud/choose-role`)
      // window.location.assign('/cloud/teacher')
    })
    this.$on('teacher', () => {
      this.$router.push(`/cloud/teacher-login`)
      // window.location.assign('/cloud/teacher')
    })
    this.$on('student', () => {
      this.$router.push(`/cloud/lobby`)
      // window.location.assign('/cloud/teacher')
    })
    this.$on('logout', () => {
      sAPI.logout()
      window.localStorage.removeItem('jwt-yoqb')
      window.location.assign('/cloud')
    })
  }
}
</script>

<style>

</style>
